const relativeFormatter = new Intl.RelativeTimeFormat("en", {
	numeric: "auto",
});

export function formatRelativeTime(
	timestamp: number | null | undefined,
): string {
	if (!timestamp) return "Never";
	const diffMs = timestamp - Date.now();
	const diffMinutes = Math.round(diffMs / 60000);

	if (Math.abs(diffMinutes) < 60) {
		return relativeFormatter.format(diffMinutes, "minute");
	}

	const diffHours = Math.round(diffMinutes / 60);
	if (Math.abs(diffHours) < 24) {
		return relativeFormatter.format(diffHours, "hour");
	}

	const diffDays = Math.round(diffHours / 24);
	return relativeFormatter.format(diffDays, "day");
}

/** Chat-bubble timestamp: same day -> "3:45 PM", else "May 17, 3:45 PM". */
export function formatMessageTime(
	timestamp: number | null | undefined,
): string {
	if (!timestamp) return "";
	const date = new Date(timestamp);
	const now = new Date();
	const sameDay =
		date.getFullYear() === now.getFullYear() &&
		date.getMonth() === now.getMonth() &&
		date.getDate() === now.getDate();
	if (sameDay) {
		return date.toLocaleTimeString(undefined, {
			hour: "numeric",
			minute: "2-digit",
		});
	}
	return date.toLocaleString(undefined, {
		month: "short",
		day: "numeric",
		hour: "numeric",
		minute: "2-digit",
	});
}
